const routes = [
    {
        path: "/student/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true
        }
    }
];

export default routes;
